import gql from 'graphql-tag';

export const onboardDeviceBatchMutation = gql`
  mutation ($input: OnboardDeviceBatchInput) {
    onboardDeviceBatch(input: $input)
    {
      deviceBatchId
      serial
      remark
      status
      date
    }
  }
`
